export default function (arr, key) {
  const result = []

  arr.forEach(item => {
    if (key in item) {
      result.push(item[key])
    }
  })

  return result
}
